<H4>{{this.pageTitle}}</H4>
<ul>
    <li><a routerLink="/AlgorithmRegEx">[ALGORITMOS - EXPRESIONES REGULARES]</a></li>
    <li><a routerLink="/AlgorithmSort">[ALGORITMOS - ORDENAMIENTO]</a></li>
    <li><a routerLink="/AlgorithmDijkstra">[ALGORITMOS - DISTANCIA MAS CORTA]</a></li>
</ul>
<hr>
<a routerLink="/Home">Volver al Menú</a>
